import script from "./DSDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./DSDate.vue?vue&type=script&setup=true&lang=ts"

import "./DSDate.vue?vue&type=style&index=0&id=554a3644&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554a3644"]])

export default __exports__